import { NgModule } from '@angular/core'
import { NZ_ICONS, NzIconModule } from 'ng-zorro-antd/icon'

import {
  AlertOutline,
  AndroidOutline,
  AppleOutline,
  ArrowLeftOutline,
  AuditOutline,
  BookOutline,
  CalendarOutline,
  CaretDownOutline,
  CaretRightOutline,
  CaretUpOutline,
  ChromeOutline,
  ClockCircleOutline,
  CopyOutline,
  DashboardOutline,
  DeleteOutline,
  DownloadOutline,
  EditFill,
  EyeInvisibleOutline,
  EyeOutline,
  FallOutline,
  FileImageOutline,
  FileOutline,
  FileTextOutline,
  FileTwoTone,
  FormOutline,
  IdcardOutline,
  InfoCircleOutline,
  InfoCircleTwoTone,
  LineChartOutline,
  LinkOutline,
  LockOutline,
  LogoutOutline,
  MailOutline,
  MenuFoldOutline,
  MenuUnfoldOutline,
  MobileOutline,
  NotificationOutline,
  NotificationTwoTone,
  PauseOutline,
  PhoneOutline,
  PictureOutline,
  PlusOutline,
  QrcodeOutline,
  QuestionCircleOutline,
  SaveOutline,
  SearchOutline,
  SendOutline,
  StopOutline,
  SyncOutline,
  TeamOutline,
  UndoOutline,
  UnlockOutline,
  UnorderedListOutline,
  UserOutline,
  WindowsOutline,
} from '@ant-design/icons-angular/icons'
import {
  MkbCloseOutline,
  MkbDeleteOutline,
  MkbEditOutline,
  MkbEnvelopeOutline,
  MkbPlusOutline,
  MkbTargetOutline,
} from './ui/mkb-icons'
// import { MkbEditOutline } from './ui/icons'

const icons = [
  PictureOutline,
  SyncOutline,
  StopOutline,
  QrcodeOutline,
  EditFill,
  DeleteOutline,
  EyeInvisibleOutline,
  CopyOutline,
  CaretUpOutline,
  CaretDownOutline,
  PlusOutline,
  MailOutline,
  MenuFoldOutline,
  MenuUnfoldOutline,
  FileOutline,
  FileTwoTone,
  ArrowLeftOutline,
  DashboardOutline,
  FormOutline,
  UserOutline,
  LockOutline,
  UnlockOutline,
  BookOutline,
  AuditOutline,
  SearchOutline,
  LinkOutline,
  LogoutOutline,
  PhoneOutline,
  MkbEditOutline,
  MkbDeleteOutline,
  MkbPlusOutline,
  MkbCloseOutline,
  MkbTargetOutline,
  MkbEnvelopeOutline,
  SaveOutline,
  AndroidOutline,
  AppleOutline,
  ChromeOutline,
  CaretRightOutline,
  AlertOutline,
  PauseOutline,
  EyeOutline,
  ClockCircleOutline,
  UndoOutline,
  WindowsOutline,
  NotificationOutline,
  NotificationTwoTone,
  LineChartOutline,
  DownloadOutline,
  AuditOutline,
  SendOutline,
  FileImageOutline,
  InfoCircleTwoTone,
  InfoCircleOutline,
  QuestionCircleOutline,
  FallOutline,
  IdcardOutline,
  CalendarOutline,
  MobileOutline,
  TeamOutline,
  FileTextOutline,
  UnorderedListOutline,
]

@NgModule({
  imports: [NzIconModule],
  exports: [NzIconModule],
  providers: [{ provide: NZ_ICONS, useValue: icons }],
})
export class IconsProviderModule {}
